<ion-router-outlet
  [animated]="pageTransitionAnimated$ | async"
></ion-router-outlet>
